export default class SousTraitant {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.prenom = data.prenom || null;
    this.raison_sociale = data.raison_sociale || null;
    this.num_siret = data.num_siret;
  }
  update(data) {
    this.id = data.id;
    this.name = data.name;
    this.prenom = data.prenom ?? null;
    this.raison_sociale = data.raison_sociale ?? null;
    this.num_siret = data.num_siret;
  }

  static create(data) {
    return new SousTraitant(data);
  }
}
